import {useState, useRef, useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'

import Style from './style'

import Search from 'widget/Search'
import Pagenation from 'widget/Pagenation'

import DefaultModal from 'shared/ui/DefaultModal'
import DefaultButton from 'shared/ui/DefaultButton'
import TStyle from 'shared/style/tableStyle'

import useGetAccountListWithStoreTicket from 'entity/account/useGetAccountListWithStoreTicket'
import usePostAccountStoreTicketGive from 'entity/account/usePostAccountStoreTicketGive'
import usePutAccountStoreTicketCollect from 'entity/account/usePutAccountStoreTicketCollect'

import TableLoading from 'shared/ui/TableLoading'
import SortableHeader from 'shared/ui/SortableHeader'
import useGetStoreTicketTypes from 'entity/store/useGetStoreTicketTypes'

const GiveModal = ({closeEvent}) => {
	const [searchParams, setSearchParams] = useSearchParams()
	const prefix = 'giveModal'
	const page = searchParams.get(`${prefix}_page`)
	const search = searchParams.get(`${prefix}_search`)

	const [ticketTypes] = useGetStoreTicketTypes()

	const [accountIdx, setAccountIdx] = useState()
	const numberRef = useRef()
	const voucherTypeRef = useRef()

	const [accountList, isLoading] = useGetAccountListWithStoreTicket(prefix)
	const [postTicket] = usePostAccountStoreTicketGive(
		accountIdx,
		numberRef,
		voucherTypeRef
	)
	const [collectTicket] = usePutAccountStoreTicketCollect(
		accountIdx,
		numberRef,
		voucherTypeRef
	)

	const sizeList = ['short', 'short', 'medium', 'expand', 'medium']
	const tableHeadList = [
		{label: '선택'},
		{label: 'IDX', sortKey: 'idx'},
		{label: '이름', sortKey: 'name'},
		{label: '닉네임', sortKey: 'nickname'},
		{label: '보유 개수', sortKey: 'ticket_number'},
	]
	const tableDataList = accountList?.data?.account_list

	const changeCheckboxEvent = (idx) => {
		if (accountIdx !== idx) setAccountIdx(idx)
		else setAccountIdx(null)
	}

	useEffect(() => {
		setAccountIdx(null)
	}, [page, search])

	const voucherTypeOptions = [
		{value: '', label: '== 모든 유형 =='},
		...(ticketTypes?.data?.ticket_types || [])
			.sort((a, b) => a.idx - b.idx)
			.map((voucher) => ({
				value: voucher.idx,
				label: voucher.name,
			})),
	]

	const handleClose = () => {
		const newParams = new URLSearchParams(searchParams)
		Array.from(newParams.keys()).forEach((key) => {
			if (key.startsWith(`${prefix}_`)) {
				newParams.delete(key)
			}
		})
		setSearchParams(newParams)
		closeEvent && closeEvent()
	}

	return (
		<DefaultModal title={'매장 이용권 관리'} closeEvent={handleClose}>
			<Style.Wrapper>
				<Search
					placeholder='IDX / 닉네임 입력'
					qualificationFilter={false}
					prefix={prefix}
				/>

				<TableLoading isLoading={isLoading}>
					<TStyle.TableDiv>
						<TStyle.TableInner>
							<TStyle.TableRow $title>
								{tableHeadList.map((elem, index) => (
									<TStyle.Data key={index} $title $size={sizeList[index]}>
										<SortableHeader sortKey={elem.sortKey} prefix={prefix}>
											{elem.label}
										</SortableHeader>
									</TStyle.Data>
								))}
							</TStyle.TableRow>
							{tableDataList?.map((elem, index) => (
								<TStyle.TableRow
									key={index}
									$odd={index % 2 === 1}
									onClick={() => changeCheckboxEvent(elem?.idx)}
								>
									<TStyle.Data $size={sizeList[0]}>
										<input
											type='checkbox'
											checked={accountIdx === elem?.idx}
											onChange={() => changeCheckboxEvent(elem?.idx)}
										/>
									</TStyle.Data>
									<TStyle.Data $size={sizeList[1]}>{elem?.idx}</TStyle.Data>
									<TStyle.Data $size={sizeList[2]}>{elem?.name}</TStyle.Data>
									<TStyle.Data $size={sizeList[3]}>
										{elem?.nickname}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[4]}>
										<TStyle.Count>
											<p>총합: {elem?.ticket_number}</p>
											{elem?.ticket_detail?.length ? <hr /> : <></>}
											{elem?.ticket_detail?.map((detail) => (
												<p>
													<span>{detail.name}: </span>
													<span>{detail.number}</span>
												</p>
											))}
										</TStyle.Count>
									</TStyle.Data>
								</TStyle.TableRow>
							))}
						</TStyle.TableInner>
					</TStyle.TableDiv>
				</TableLoading>

				<Pagenation maxPage={accountList?.data?.max_page} prefix={prefix} />

				<Style.GiveDiv>
					<select ref={voucherTypeRef} defaultValue={''}>
						{voucherTypeOptions.map((option) => (
							<option key={option.value} value={option.value}>
								{option.label}
							</option>
						))}
					</select>
					<input placeholder='개수 입력' ref={numberRef} />
					<DefaultButton small fitWidth expandHeight clickEvent={postTicket}>
						지급
					</DefaultButton>
					<DefaultButton small fitWidth expandHeight clickEvent={collectTicket}>
						회수
					</DefaultButton>
				</Style.GiveDiv>
			</Style.Wrapper>
		</DefaultModal>
	)
}

export default GiveModal
